import { useSelector } from "react-redux";
import { AssetList } from "../asset/assetList/AssetList";
import { HomeDashboard } from "../home/home";
import { useState,useEffect } from "react";


export const LandingPage=()=>{
    
    const Lander= useSelector(state=>state.authorizationData.landingPage);
    const [lander,setLander]=useState(Lander);
    
    useEffect(()=>{
        setLander(Lander);
    },[Lander]);

    if(lander==='Home')
    {
      return <><HomeDashboard/></>
    }
    else if(lander==='Asset')
    {
      return <><AssetList/></>
    }
}